import React from 'react'
import { Button, Col, Popconfirm, Row } from 'antd'

function FooterButtons(props) {
  const {
    isNew,
    isEdit,
    isRemovable,
    isUpdatable = isEdit,
    visible,
    remove,
    removing,
    submit,
    update,
    submitting,
    title,
    style,
    disableSubmit,
  } = props
  console.log(!isNew, !!update, !!isUpdatable, !!update || !!isUpdatable, !isNew && (!!update || !!isUpdatable))

  const message = `Are you sure remove this ${title}?`
  return (
    visible && (
      <Row style={style}>
        <Col span={24} style={{ textAlign: 'right' }}>
          {isEdit && (
            <Popconfirm title={message} onConfirm={remove} okText="Yes" cancelText="No">
              {isRemovable && (
                <Button type="danger" loading={removing} style={{ marginLeft: 8, marginRight: 8 }}>
                  Remove
                </Button>
              )}
            </Popconfirm>
          )}
          {isNew && (
            <Button
              data-testid={`sumbit-${title}`}
              disabled={disableSubmit}
              loading={submitting}
              type="primary"
              onClick={submit}>
              Submit
            </Button>
          )}

          {isEdit && (!!update && !!isUpdatable) && (
            <Button data-testid={`sumbit-${title}`} loading={submitting} type="primary" onClick={update}>
              Update
            </Button>
          )}
          {props.children}
        </Col>
      </Row>
    )
  )
}

FooterButtons.defaultProps = {
  visible: true,
  isRemovable: true,
}

export default FooterButtons
